module.exports = __webpack_public_path__ + "static/img/Logo6_BelmondGovernorsResidence.54950ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo6_BelmondGovernorsResidence.png
// module id = 312
// module chunks = 2